/* eslint-disable camelcase */
import React from 'react'
import {
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import { TreeItem } from '@material-ui/lab'

const useStyle = makeStyles(() => ({
  label: ({ isTextOrExtended }) => ({
    fontStyle: isTextOrExtended ? 'italic' : 'normal',
    whiteSpace: 'pre-line',
    marginBottom: '0.35em',
  }),
  content: ({ isRadioFirstLabel }) => ({
    display: isRadioFirstLabel ? 'none' : '',
  }),
}))

const ChoiceTreeItem = ({ choice, parentCriteria, ...props }) => {
  const theme = useTheme()
  const downXs = useMediaQuery(theme.breakpoints.down('xs'))

  const { criteria_type, choices } = parentCriteria
  const label = choice.choice_label
  const isRadioFirstLabel =
    criteria_type === 'radio_extended' &&
    choices[0].choice_label === label &&
    !downXs
  const classes = useStyle({
    isTextOrExtended: choice.is_text_or_extended,
    isRadioFirstLabel,
  })

  return (
    <TreeItem
      className={classes.label}
      classes={{
        content: classes.content,
      }}
      label={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <Typography variant="h5" component="span">
          {label}
        </Typography>
      }
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
}

export default ChoiceTreeItem
